import TagList from "../components/tag/TagCrud";

const TagCrudPage = () => {
  return (
    <>
      <TagList />
    </>
  );
};

export default TagCrudPage;
